<template>
  <q-icon name="o_info" class="cursor-pointer secondary-color">
    <q-popup-proxy>
      <div class="__CPopupInfo-Content">
        <slot />
      </div>
    </q-popup-proxy>
  </q-icon>
</template>

<script>
import Vue from 'vue';

const messages = {
  en: {},
  ja: {},
};

export default Vue.extend({
  name: 'CPopupProxy',
  i18n: { messages },
});
</script>

<style lang="scss" scoped>
.__CPopupInfo-Content {
  padding: $space-sm;
  font-size: $font-size-sm;
}
</style>
